import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { createAppRouter } from './router';
import { consumePlacementCode } from '../shared/placement';

/**
 * §15.1, §11.2 ТЗ. Запуск приложения.
 *
 * Вынесено из `main.tsx` ради теста: здесь сходятся обмен кода размещения и
 * адрес, с которого начинает маршрутизатор, а проверить это можно только
 * запустив приложение целиком.
 *
 * Код размещения обменивается **до первой отрисовки**: иначе охрана маршрута
 * успевает увести человека на форму входа, и он видит её вместо своей панели.
 * Обмен заодно правит адрес — убирает одноразовый код и разворачивает ссылку из
 * задачи Bitrix24 в карточку (§11.2), — поэтому маршрутизатор создаётся после
 * него. Нынешняя история TanStack замечает и более поздний `replaceState`, но
 * это её внутреннее устройство, а не обещание: порядок дешевле, чем зависимость.
 */
export async function startApp(root: HTMLElement, queryClient: QueryClient): Promise<void> {
  await consumePlacementCode();

  const router = createAppRouter(queryClient);
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
